<template>
  <div class="sticker-list-wrap">
    <el-card class="sticker-list-body">
      <!-- 筛选区域 -->
      <el-form :inline="true" size="mini" class="demo-form-inline">
        <el-form-item label="筛选">
          <el-input
              placeholder="溯源码"
              class="sticker-select-input"
              size="mini"
              v-model="selects.traceable_code"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
              placeholder="防伪码"
              class="sticker-select-input"
              size="mini"
              v-model="selects.security_code"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
              placeholder="gid"
              class="sticker-select-input"
              size="mini"
              v-model="selects.goods_id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
              placeholder="订单号"
              class="sticker-select-input"
              size="mini"
              v-model="selects.order_id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
              placeholder="店铺联系手机"
              class="sticker-select-input"
              size="mini"
              v-model="selects.shop_contacts_mobile"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
              placeholder="用户id"
              class="sticker-select-input"
              size="mini"
              v-model="selects.ac_id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="selects.platform_id" placeholder="所属平台" clearable class="sticker-select">
            <el-option
                v-for="item in platformList"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="selects.status" class="sticker-select">
            <el-option
                v-for="(item,index) in selects.statusList"
                :key="index"
                :value="item.value"
                :label="item.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="selects.sticker_log_id" filterable placeholder="所有批次">
            <el-option
                v-for="(item,index) in this.stickerLogList"
                :key="index"
                :value="item.value"
                :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getSelects">筛选</el-button>
          <el-button size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row class="common-con-btns mb5">
        <el-col :span="24">
          <el-alert>温馨提示：由于数据量较大，列表默认展示最近一个批次的溯源码数据。如需查询其他的，请进行筛选！</el-alert>
        </el-col>
      </el-row>
      <!-- 表格区域 -->
      <el-table
          class="page-wrap"
          :data="dataList"
          ref="listTable"
          row-key="relation_id"
          header-row-class-name="table-black-header"
          style="width: 100%"
      >
        <el-table-column label="溯源码/防伪码" min-width="120">
          <template slot-scope="scope">
            <div>溯源码：{{ scope.row.traceable_code ? scope.row.traceable_code : '-' }}</div>
            <div>防伪码：{{ scope.row.security_code ? scope.row.security_code : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="商品">
          <template slot-scope="scope" v-if="scope.row.goods_info">
            <div>gid:{{ scope.row.goods_info.goods_id }}</div>
            <div>{{ scope.row.goods_info.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="所属平台" prop="platform_id" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.platform_id == 1">它品</span>
            <span v-if="scope.row.platform_id == 8">奇葩熊</span>
          </template>
        </el-table-column>
        <el-table-column label="积分值" prop="score"></el-table-column>
        <el-table-column label="仓库与订单" min-width="100">
          <template slot-scope="scope">
            <div>仓库id：{{ scope.row.warehouse_id ? scope.row.warehouse_id : '-' }}</div>
            <div>出库单号：{{ scope.row.outer_id ? scope.row.outer_id : '-' }}</div>
            <div>发货单号：{{ scope.row.order_id ? scope.row.order_id : '-' }}</div>
            <div>订单号：{{ scope.row.sub_oid ? scope.row.sub_oid : '-' }}</div>
            <div>领用单号：{{ scope.row.recipients_number ? scope.row.recipients_number : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="店铺信息" min-width="120">
          <template slot-scope="scope" v-if="scope.row.shop_info">
            <div>店铺名：{{ scope.row.shop_info.name }}</div>
            <div>手机：{{ scope.row.shop_info.contacts_mobile }}</div>
          </template>
        </el-table-column>
        <el-table-column label="用户id">
          <template slot-scope="scope">
            <span
                @click="toUserDetail(scope.row.user_info.ac_id)"
                class="cursor underline"
                v-if="scope.row.user_info"
            >{{ scope.row.user_info.ac_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" min-width="160">
          <template slot-scope="scope">
            <div>生成：{{ scope.row.created_at ? scope.row.created_at : '-' }}</div>
            <div>激活：{{ scope.row.activated_at ? scope.row.activated_at : '-' }}</div>
            <div>领取：{{ scope.row.used_at ? scope.row.used_at : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{ selects.statusList.find(v => { return v.value == scope.row.status }) ? selects.statusList.find(v => { return v.value == scope.row.status }).text : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="delSticker(scope.row.id)">作废</el-button>
            <el-button type="text" size="mini" @click="toDetail(scope.row.traceable_code)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="page.total"
            :page-size="page.pageSize"
            @current-change="currentPageChange"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import {stickerApi} from "@/api/sticker";

export default {
  data() {
    return {
        // 有权限的平台列表
        platformList: [],
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },
      selects: {
        platform_id: '',
        traceable_code: "",
        security_code: "",
        goods_id: "",
        order_id: "",
        shop_contacts_mobile: "",
        ac_id: "",
        status: 0,
        sticker_log_id: 0,
        statusList: [
          {value: 0, text: "全部状态"},
          {value: 1, text: "待绑定溯源商品"},
          {value: 2, text: "已绑定溯源商品"},
          {value: 3, text: "用户已查询真伪"},
          {value: 4, text: "溯源码已废弃"}
        ]
      },
      dataList: [],
      stickerLogList: [],
    };
  },
  created() {
    this.getPlatformPermission()
    this.getBatchStickerLogs();
    this.getList();
  },
  methods: {
    // 获取有权限的平台列表
    getPlatformPermission() {
        this.$EpetJs.Common.ajax('get', stickerApi.getPlatformPermissionUrl).then(res => {
            if(res) {
                this.platformList = res.data.data || []
                if(this.platformList.length > 0) {
                    this.selects.platform_id = this.platformList[0].key
                }
            }
        })
    },
    /**
     * 获取贴纸列表
     */
    getList() {
      const pam = {
        page: this.page.currentPage,
        per_page: this.page.pageSize,
        goods_id: this.selects.goods_id,
        order_id: this.selects.order_id,
        shop_contacts_mobile: this.selects.shop_contacts_mobile,
        ac_id: this.selects.ac_id,
        status: this.selects.status,
        sticker_log_id: this.selects.sticker_log_id,
        platform_id: this.selects.platform_id,
        security_code: this.selects.security_code
      };
      if (this.selects.traceable_code) {
        pam.traceable_code = this.selects.traceable_code;
      }
      this.$EpetJs.Common.get(stickerApi.getStickerListUrl, pam, {
        needLoading: true
      }).then(res => {
        if (res) {
          this.dataList = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total;
          }
        }
      });
    },
    /**
     * 作废贴纸
     */
    delSticker(id) {
      this.$EpetJs.Common.confirm("是否确定作废该贴纸?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.$EpetJs.Common.patch(
                stickerApi.getStickerListUrl + "/" + id
            ).then(res => {
              if (res) {
                this.$message.success("作废成功！");
                this.getList();
              }
            });
          })
          .catch(() => {
          });
    },
    /**
     * 查看详情
     */
    toDetail(id) {
      this.$router.push("/sticker/detail/" + id);
    },
    /**
     * 跳转用户详情
     */
    toUserDetail(acId) {
      this.$router.push("/client_user/detail/" + acId);
    },
    /**
     * 当前页改变
     */
    currentPageChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    /**
     * 筛选
     */
    getSelects() {
      this.page.currentPage = 1;
      this.getList();
    },
    /**
     * 重置
     */
    reset() {
      this.selects.traceable_code = "";
      this.selects.goods_id = "";
      this.selects.order_id = "";
      this.selects.shop_contacts_mobile = "";
      this.selects.ac_id = "";
      this.selects.status = 0;
      this.selects.sticker_log_id = 0;
      this.selects.security_code = "";
      this.page.currentPage = 1;
      this.getList();
    },
    /**
     * 获取贴纸码批次
     */
    getBatchStickerLogs() {
      this.$EpetJs.Common.get(stickerApi.getStickerLogsBatchUrl).then(res => {
        if (res) {
          if (res.data.data) {
            let tempArr = []
            res.data.data.forEach(item => {
              let obj = {}
              obj.value = item.id && parseInt(item.id)
              obj.label = `[${obj.value}] ${item.batch_name}`
              tempArr.push(obj)
            })
            this.stickerLogList = tempArr
            this.stickerLogList.unshift({'value': 0, 'label': '[0] 所有批次'})
          }
        }
      });
    }
  }
};
</script>
<style lang="less">
.sticker-select-input,
.sticker-select {
  width: 110px;
}

.sticker-list-wrap {
  .sticker-list-body {
    min-height: calc(100vh - 60px);

    .delete-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }

    .detail-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
</style>
